var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.723,
    height: 14.372,
    viewBox: "0 0 13.723 14.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25577",
    "data-name": "Path 25577",
    d: "M9.139-8.1v-5.048H5.744V-8.1H1.08v3.277H5.744V.22H9.139V-4.828H13.8V-8.1Z",
    transform: "translate(-0.58 13.652)",
    fill: "none",
    stroke: "#220046",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcons);
export default __webpack_public_path__ + "static/media/add-icons.e971b866fe0d5da3fe4b55c46597dcd2.svg";
export { ForwardRef as ReactComponent };